module.exports = __webpack_public_path__ + "img/VI.bfed07ad.png";